import TitikPemeriksaan from "../../../../../components/categories/operational/qr_patrol/titik_pemeriksaan/Home";
export default function Home() {
  
  return (
    <TitikPemeriksaan />
  );
}
